module.exports = "<div #idcontent class=\"disable-selection\" ></div>"